import axios from 'axios';
import qs from 'qs';
import { USAGE_LABEL } from '@/constants';

const apiProjects = {
    delete(params, idToken, projectId) {
        return axios
            .delete(`${process.env.VUE_APP_APIURL}/projects/${projectId}`, {
                headers: {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                },
                data: params
            })
            .catch(error => {
                throw error;
            });
    },
    get(idToken, params) {
        return axios
            .get(`${process.env.VUE_APP_APIURL}/projects`, {
                headers: {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                },
                params: params
            })
            .catch(error => {
                throw error;
            });
    },
    post(params, idToken) {
        return axios
            .post(`${process.env.VUE_APP_APIURL}/projects`, params, {
                headers: {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                }
            })
            .catch(error => {
                throw error;
            });
    },
    put(params, idToken, projectId) {
        return axios
            .put(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            )
            .catch(error => {
                throw error;
            });
    },

    actions: {
        get(idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/actions`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    cancelToken: cancelToken
                }
            );
        },
        put(params, idToken, projectId) {
            return axios.put(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/actions`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        }
    },

    authorization: {
        ga: {
            redirect(idToken, projectId) {
                location.href = `${process.env.VUE_APP_APIURL}/projects/${projectId}/authorization/ga?idToken=${idToken}`;
            }
        },
        ga4: {
            redirect(idToken, projectId, tmpKey) {
                location.href = `${process.env.VUE_APP_APIURL}/projects/${projectId}/authorization/ga4?idToken=${idToken}&tmpKey=${tmpKey}`;
            }
        },
        gsc: {
            redirect(idToken, projectId) {
                location.href = `${process.env.VUE_APP_APIURL}/projects/${projectId}/authorization/gsc?idToken=${idToken}`;
            }
        }
    },

    competitorKeywords: {
        get(params, idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/competitor-keywords`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        }
    },
    competitorSites: {
        get(idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/competitor-sites`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        post(params, idToken, projectId) {
            return axios.post(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/competitor-sites`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        delete(idToken, projectId, siteId) {
            return axios.delete(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/competitor-sites/${siteId}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        keyword: {
            get(idToken, projectId, competitorSiteId, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/competitor-sites/${competitorSiteId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        cancelToken: cancelToken
                    }
                );
            }
        }
    },

    contentPlans: {
        answer: {
            post(
                params,
                idToken,
                projectId,
                contentPlanId,
                plotType,
                cancelToken
            ) {
                return axios.post(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/${contentPlanId}/answers/${plotType}`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        cancelToken: cancelToken
                    }
                );
            }
        },
        keyword: {
            post(params, idToken, projectId, cancelToken) {
                return axios.post(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/keyword`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        cancelToken: cancelToken
                    }
                );
            }
        },
        keywords: {
            get(idToken, projectId, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/keywords`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        cancelToken: cancelToken
                    }
                );
            },
            delete(params, idToken, projectId, keywordId) {
                return axios.delete(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/keywords/${keywordId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                );
            }
        },
        pageVolumes: {
            get(params, idToken, projectId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/page-volumes`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        },
        plots: {
            get(idToken, projectId, contentPlanId, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/${contentPlanId}/plots`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        cancelToken: cancelToken
                    }
                );
            },
            put(params, idToken, projectId, contentPlanId, cancelToken) {
                return axios.put(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/${contentPlanId}/plots`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        cancelToken: cancelToken
                    }
                );
            }
        },
        searchVolumes: {
            get(params, idToken, projectId, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/search-volumes`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        },
        siteIndex: {
            get(params, idToken, projectId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/site-index`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        },
        siteKeywordIndex: {
            get(params, idToken, projectId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/site-keyword-index`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        },
        suggestMap: {
            get(params, idToken, projectId, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/suggest-map`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            },
            download: {
                get(params, idToken, projectId) {
                    return axios.get(
                        `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/suggest-map/download`,
                        {
                            headers: {
                                Authorization: 'Bearer ' + idToken,
                                'X-From': location.href
                            },
                            params: params,
                            responseType: 'blob'
                        }
                    );
                }
            }
        },
        tdh: {
            get(params, idToken, projectId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    index &&
                    (process.env.VUE_APP_ENV === 'local' ||
                        process.env.VUE_APP_ENV === 'demo' ||
                        process.env.VUE_APP_ENV === 'prototype')
                ) {
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/tdh`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            },
            download: {
                get(params, idToken, projectId) {
                    return axios.get(
                        `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/tdh/download`,
                        {
                            headers: {
                                Authorization: 'Bearer ' + idToken,
                                'X-From': location.href
                            },
                            params: params,
                            responseType: 'blob'
                        }
                    );
                }
            }
        },
        tdhWords: {
            get(params, idToken, projectId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    index &&
                    (process.env.VUE_APP_ENV === 'local' ||
                        process.env.VUE_APP_ENV === 'demo' ||
                        process.env.VUE_APP_ENV === 'prototype')
                ) {
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/tdh-words`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        },
        word: {
            get(params, idToken, projectId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/content-plans/word`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        }
    },

    dailySerps: {
        get(params, idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/daily-serps`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        }
    },

    ga4: {
        put(params, idToken, projectId) {
            return axios.put(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga4`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        }
    },
    ga4Goals: {
        get(idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga4-goals`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    cancelToken: cancelToken
                }
            );
        }
    },
    ga4MetricsOrganic: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga4-metrics-organic`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },
    ga4MetricsSummaries: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga4-metrics-summaries`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },
    ga4TermOrganic: {
        get(params, idToken, projectId, cancelToken, type) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                type &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-type'] = type;
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga4-term-organic`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },
    ga4TermSummaries: {
        get(params, idToken, projectId, cancelToken, type) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                type &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-type'] = type;
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga4-term-summaries`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    goals: {
        get(idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/goals`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    cancelToken: cancelToken
                }
            );
        }
    },

    influxKeywordSummaries: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/influx-keyword-summaries`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    keywordAnalyses: {
        update: {
            post(params, idToken, projectId) {
                return axios.post(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/keyword-analyses/update`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                );
            }
        }
    },

    keywordAnalysis: {
        download: {
            get(params, idToken, projectId) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    headers['x-api-fake-when-type'] = params.dataType;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/keyword-analysis/download`,
                    {
                        headers: headers,
                        params: params,
                        responseType: 'blob',
                        paramsSerializer(params) {
                            return qs.stringify(params);
                        }
                    }
                );
            }
        }
    },

    keywordRanks: {
        get(params, idToken, projectId, cancelToken) {
            if (!params.device) {
                params.device = 'desktop';
            }
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/keyword-ranks`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    keywords: {
        get(params, idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/keywords`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        }
    },

    metricsOrganic: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/metrics-organic`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    metricsSummaries: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/metrics-summaries`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    monthlyReports: {
        download: {
            get(idToken, projectId, reportId) {
                const headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/monthly-reports/download/${reportId}`,
                    {
                        headers: headers
                    }
                );
            }
        },
        list: {
            get(idToken, projectId) {
                const headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/monthly-reports/list`,
                    {
                        headers: headers
                    }
                );
            }
        }
    },

    nominatedKeywords: {
        delete(keywordId, idToken, projectId) {
            return axios.delete(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/nominated-keywords/${keywordId}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        get(idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/nominated-keywords`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    cancelToken: cancelToken
                }
            );
        },
        post(params, idToken, projectId) {
            return axios.post(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/nominated-keywords`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        }
    },

    observationKeywords: {
        delete(idToken, projectId, keywordId) {
            return axios.delete(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords/${keywordId}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        get(idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    cancelToken: cancelToken
                }
            );
        },
        post(params, idToken, projectId) {
            return axios.post(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        detail: {
            get(params, idToken, projectId, keywordId, cancelToken, index) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    index = ((index - 1) % 30) + 1;
                    headers['x-api-fake-when-index'] = index;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords/${keywordId}/ranks`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            },
            metricsSummary: {
                get(params, idToken, projectId, keywordId, cancelToken) {
                    return axios.get(
                        `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords/${keywordId}/metrics-summary`,
                        {
                            headers: {
                                Authorization: 'Bearer ' + idToken,
                                'X-From': location.href
                            },
                            params: params,
                            cancelToken: cancelToken
                        }
                    );
                }
            },
            metricsTerm: {
                get(params, idToken, projectId, keywordId, cancelToken) {
                    return axios.get(
                        `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords/${keywordId}/metrics-term`,
                        {
                            headers: {
                                Authorization: 'Bearer ' + idToken,
                                'X-From': location.href
                            },
                            params: params,
                            cancelToken: cancelToken
                        }
                    );
                }
            }
        },
        download: {
            get(params, idToken, projectId) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords/download`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params,
                        responseType: 'blob'
                    }
                );
            }
        },
        search: {
            get(params, idToken, projectId) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/observation-keywords/search`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params
                    }
                );
            }
        }
    },

    pageCheckups: {
        delete(idToken, projectId, pageCheckupId) {
            return axios.delete(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/page-checkups/${pageCheckupId}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        get(params, idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/page-checkups`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        },
        post(params, idToken, projectId) {
            return axios.post(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/page-checkups`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        result: {
            get(params, idToken, projectId, id, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/page-checkups/${id}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        }
    },

    project: {
        get(idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        }
    },

    proposals: {
        get(params, idToken, projectId, cancelToken) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                params.type &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-type'] = params.type;
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/proposals`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        },
        log: {
            post(params, idToken, projectId) {
                return axios.post(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/proposals/log`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                );
            }
        }
    },

    publishedDate: {
        get(idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/published-date`,
                {
                    headers: headers
                }
            );
        },
        put(params, idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.put(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/published-date`,
                params,
                {
                    headers: headers
                }
            );
        }
    },

    researchKeywords: {
        delete(params, idToken, projectId) {
            return axios.delete(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/research-keywords`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    data: params
                }
            );
        },
        get(params, idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/research-keywords`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        },
        post(params, idToken, projectId) {
            return axios.post(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/research-keywords`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        }
    },

    searchSummaries: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/search-summaries`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    searchTerms: {
        get(params, idToken, projectId, cancelToken, term, type) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                term &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-term'] = term;
            }
            if (
                type &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-type'] = type;
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/search-terms`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        },
        download: {
            get(params, idToken, projectId, type) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    type &&
                    (process.env.VUE_APP_ENV === 'local' ||
                        process.env.VUE_APP_ENV === 'demo' ||
                        process.env.VUE_APP_ENV === 'prototype')
                ) {
                    headers['x-api-fake-when-type'] = type;
                }
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/search-terms/download`,
                    {
                        headers: headers,
                        params: params,
                        responseType: 'blob'
                    }
                );
            }
        }
    },

    suggestAnalyses: {
        post(params, idToken, projectId) {
            return axios.post(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/suggest-analyses`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        serps: {
            get(params, idToken, projectId, cancelToken) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/suggest-analyses/serps`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params,
                        cancelToken: cancelToken
                    }
                );
            }
        }
    },

    relatedWordAnalysis: {
        get(params, idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/related-word-analysis`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        },
        version(idToken, projectId, keywordId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/related-word-analysis/${keywordId}/versions`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        duplicateCheck(params, idToken, projectId, keywordId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/related-word-analysis/${keywordId}/duplicate-check`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params
                }
            );
        },
        download: {
            get(params, idToken, projectId) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/related-word-analysis/download`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        params: params,
                        responseType: 'blob'
                    }
                );
            }
        }
    },
    serps: {
        get(params, idToken, projectId, cancelToken) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/serps`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    },
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },
    tasks: {
        count: {
            get(idToken, projectId) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/tasks/count`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                );
            }
        },
        delete(idToken, projectId, taskId) {
            return axios.delete(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/tasks/${taskId}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        download: {
            get(idToken, projectId) {
                return axios.get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/tasks/download`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        },
                        responseType: 'blob'
                    }
                );
            }
        },
        get(params, idToken, projectId, cancelToken) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                process.env.VUE_APP_ENV === 'local' ||
                process.env.VUE_APP_ENV === 'demo' ||
                process.env.VUE_APP_ENV === 'prototype'
            ) {
                if (params.columns) {
                    headers['x-api-fake-when-columns'] = params.columns;
                }

                if (params.types) {
                    headers['x-api-fake-when-types'] = params.types;
                }
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/tasks`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        },
        put(params, idToken, projectId, taskId) {
            return axios.put(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/tasks/${taskId}`,
                params,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        },
        siteAnalysis: {
            post(params, idToken, projectId) {
                return axios.post(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/tasks/site-analysis`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                );
            }
        }
    },

    existingContentsSummary: {
        get(idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/existing-contents/summary`,
                {
                    headers: headers
                }
            );
        }
    },

    existingContentsTerm: {
        get(idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/existing-contents/term`,
                {
                    headers: headers
                }
            );
        }
    },

    gaVersion: {
        get(idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga-version`,
                {
                    headers: headers
                }
            );
        },
        put(params, idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.put(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/ga-version`,
                params,
                {
                    headers: headers
                }
            );
        }
    },

    rankedContentSummary: {
        get(idToken, projectId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/new-contents/summary`,
                {
                    headers: headers
                }
            );
        }
    },

    termOrganic: {
        get(params, idToken, projectId, cancelToken, type) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                type &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-type'] = type;
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/term-organic`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    termSummaries: {
        get(params, idToken, projectId, cancelToken, type) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                type &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                headers['x-api-fake-when-type'] = type;
            }
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/term-summaries`,
                {
                    headers: headers,
                    params: params,
                    cancelToken: cancelToken
                }
            );
        }
    },

    usages: {
        get(params, idToken, projectId, cancelToken) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };
            if (
                params.items !== 'all' &&
                (process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype')
            ) {
                if (Object.keys(USAGE_LABEL).includes(params.items)) {
                    headers['x-api-fake-when-items'] = params.items;
                }
            }
            return axios
                .get(
                    `${process.env.VUE_APP_APIURL}/projects/${projectId}/usages`,
                    {
                        headers: headers,
                        params: params,
                        cancelToken: cancelToken
                    }
                )
                .catch(error => {
                    throw error;
                });
        },
        count: {
            get(params, idToken, projectId, cancelToken) {
                let headers = {
                    Authorization: 'Bearer ' + idToken,
                    'X-From': location.href
                };
                if (
                    process.env.VUE_APP_ENV === 'local' ||
                    process.env.VUE_APP_ENV === 'demo' ||
                    process.env.VUE_APP_ENV === 'prototype'
                ) {
                    headers['x-api-fake-when-items'] = params.items;
                }
                return axios
                    .get(
                        `${process.env.VUE_APP_APIURL}/projects/${projectId}/usages/count`,
                        {
                            headers: headers,
                            params: params,
                            cancelToken: cancelToken
                        }
                    )
                    .catch(error => {
                        throw error;
                    });
            }
        }
    },

    users: {
        get(idToken, projectId) {
            return axios.get(
                `${process.env.VUE_APP_APIURL}/projects/${projectId}/users`,
                {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                }
            );
        }
    }
};
export default apiProjects;
